import { Link } from "react-router-dom";
import { Users, Search, Sparkles, TrendingUp, ShieldAlert, ArrowRight } from "lucide-react";
import { useT } from "@/content/landing";
import { Reveal } from "./Reveal";
import localBusinessStories from "@/assets/local-business-stories.jpg";
const icons = [Users, Search, Sparkles, TrendingUp, ShieldAlert];
export function Audience() {
  const t = useT();
  return <section id="zielgruppe" className="bg-[#FAFBFC] py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <Reveal>
          <h2 className="max-w-2xl text-2xl font-bold text-[#0F172A] sm:text-3xl">
            {t.audience.title}
          </h2>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-[#64748B]">
            {t.audience.lead}
          </p>
        </Reveal>
        <Reveal delay={60}>
          <div className="relative mt-10 h-48 overflow-hidden rounded-3xl border border-black/[0.06] sm:h-64 lg:h-72">
            <img src={localBusinessStories} alt="Inhaberinnen und Inhaber lokaler Unternehmen in ihrem Arbeitsalltag" loading="lazy" width={1536} height={1024} className="h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/20 via-transparent to-transparent" aria-hidden />
          </div>
        </Reveal>
        <ul className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {t.audience.items.map((item, i) => {
          const Icon = icons[i] ?? icons[0];
          return <Reveal as="li" key={item.title} delay={i * 50}>
                <div className="h-full rounded-3xl border border-black/[0.06] bg-white p-7 shadow-[0_1px_2px_rgba(15,23,42,0.04)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_40px_rgba(15,23,42,0.08)] motion-reduce:hover:translate-y-0">
                  <span className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-[#111827] text-white">
                    <Icon size={22} aria-hidden />
                  </span>
                  <h3 className="mt-6 text-lg font-semibold text-[#0F172A]">{item.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-[#64748B]">{item.body}</p>
                </div>
              </Reveal>;
        })}
          <Reveal as="li" delay={t.audience.items.length * 50}>
            <div className="flex h-full flex-col items-center justify-center rounded-3xl border border-black/[0.07] bg-gradient-to-br from-[#EEF2F6] to-[#DDE3EA] p-7 text-center">
              <h3 className="text-lg font-bold text-[#0F172A]">{t.audience.ctaTitle}</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#475569]">{t.audience.ctaBody}</p>
              <Link to="/analyse" className="mt-6 inline-flex items-center gap-2 rounded-xl bg-[#111827] px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-[#0F172A]">
                {t.audience.ctaButton}
                <ArrowRight size={16} aria-hidden />
              </Link>
            </div>
          </Reveal>
        </ul>
        <Reveal>
          <p className="mt-10 max-w-2xl text-sm leading-relaxed text-[#64748B]">
            {t.audience.note}
          </p>
        </Reveal>
      </div>
    </section>;
}